/*
*  This file contains all axios calls related to "fulfillment" process operations
*/
import axios from 'axios';
import { PROCESS_FULFILLMENT_LIST } from '../../../../utils/editor.constants';
import { fromObjectToOptions } from './fulfillment.util';

const BASE_FULFILLMENT_URL = '/app/fulfillmentFunnel';
const BASE_REQUEST_FUNNEL_URL = '/app/httpRequestFunnel/requests';

export const saveMarketingFulfillment = async (marketingFulfillmentId, config) => {
    return axios.put(`${BASE_FULFILLMENT_URL}/${marketingFulfillmentId}`, config)
        .catch((error) => {
            throw error;
        });
};

export const createMarketingFulfillment = async (title) => {
    const { data } = await axios.post(BASE_FULFILLMENT_URL, title, {
        headers: {
            'Content-Type': 'text/html',
        },
    });

    return data;
};

export const loadMarketingFulfillment = async (marketingFulfillmentId) => {
    const { data } = await axios.get(`${BASE_FULFILLMENT_URL}/${marketingFulfillmentId}`);

    return data;
};

export const loadFulfillmentOptions = async (marketingFulfillmentId) => {
    const { data } = await axios.get(`${BASE_FULFILLMENT_URL}/fulfillmentOptions/${marketingFulfillmentId}`);

    return data;
};

export const loadFulfillmentAttachmentFiles = async (marketingFulfillmentId) => {
    const { data } = await axios.get(`${BASE_FULFILLMENT_URL}/fulfillmentAttachmentFiles/${marketingFulfillmentId}`);

    return data;
};

export const loadFilesFromFilebox = async () => {
    const { data } = await axios.get(`${BASE_FULFILLMENT_URL}/loadFilesFromFilebox`);

    return data;
};

export const loadFulfillmentExportFields = async () => {
    const { data } = await axios.get(`${BASE_FULFILLMENT_URL}/fulfillmentExportFields`);

    return data.exportFields || {};
};

export const fileUpload = async (formData) => {
    const { data } = await axios.post('/app/faxFunnel/uploadFile?mediaType=json', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
        .then((response) => {
            if (response.data.hasError) {
                throw response.data;
            }

            return response;
        })
        .catch((error) => {
            throw error;
        });

    return data;
};

export const testMarketingFulfillment = async (marketingFulfillmentId, userId) => {
    const { data } = await axios.post(`${BASE_FULFILLMENT_URL}/${marketingFulfillmentId}/test/${userId}`);

    return data;
};

export const listFilteredSequences = async (payload) => {
    const {
        value,
        identifierName = 'style',
        identifierValue = PROCESS_FULFILLMENT_LIST,
        idAttributeName = 'marketingFulfillmentId',
        idAttributeValue = null,
        filterAttributeName = null,
        filterAttributeValue = null,
        filterAttributeRequired = null,
    } = payload;

    const { data } = await axios.get(`${BASE_REQUEST_FUNNEL_URL}/load-for-funnel?value=${value}&identifierName=${identifierName}&identifierValue=${identifierValue}&idAttributeName=${idAttributeName}&idAttributeValue=${idAttributeValue}&filterAttributeName=${filterAttributeName}&filterAttributeValue=${filterAttributeValue}&filterAttributeRequired=${filterAttributeRequired}`);

    return fromObjectToOptions(data?.options || {});
};

export const listFilteredCampaigns = async () => {
    const { data } = await axios.get(`${BASE_FULFILLMENT_URL}/fulfillment/authoring-copy-campaign`);

    return fromObjectToOptions(data?.funnelMap || {});
};

export const copyMarketingFulfillment = async (marketingFulfillmentId, copyFromId) => {
    const { data } = await axios.post(`${BASE_FULFILLMENT_URL}/${marketingFulfillmentId}/copyFrom/${copyFromId}`);

    return data;
};

export const syncFulfillmentLabel = async (cell) => {
    const marketingFulfillmentId = cell.value?.marketingFulfillmentId ?? 0;
    const newName = cell.value?.name ?? '';

    if (marketingFulfillmentId && newName) {
        await axios.put(`${BASE_FULFILLMENT_URL}/${marketingFulfillmentId}/name`, newName, {
            headers: {
                'Content-Type': 'text/html',
            },
        });
    }
};
